export const appConfig = {
    backendUrl: process.env.REACT_APP_BACKEND_SERVER_HOST
};

export const oauthConfig = {
    url: process.env.REACT_APP_OAUTH_SERVER_HOST,
    clientId: process.env.REACT_APP_OAUTH_CLIENT_ID,
    redirectUri: process.env.REACT_APP_OAUTH_REDIRECT_URI,
};

export const BACKGROUND_IMAGE: string = 'repeating-linear-gradient(132deg,#0000,#0000 4px,hsla(0,0%,84%,.502) 5px,hsla(0,0%,84%,.502) 6px,#0000 7px)';